const prevImageButtonDesktop = setInterval(() => {
  if (document.querySelectorAll(".customily-modal-preview-only").length) {
    clearInterval(prevImageButtonDesktop);
    const action = document.createElement("div");
    const button = document.createElement("div");
    const button_close = document.createElement("div");
    const container = document.createElement("div");
    const heading = document.createElement("div");
    const title = document.createElement("div");
    const content = document.createElement("div");

    const control_mobile = document.createElement("div");
    const control_mobile_image = document.createElement("div");
    const control_mobile_content = document.createElement("div");

    action.classList.add("preview-action");

    container.style.background = "#ffffff";
    container.style.padding = "20px";
    container.style.width = "94vw";
    container.style.maxWidth = "470px";
    container.style.borderRadius = "16px";
    container.style.position = "relative";

    title.classList.add("preview-headline");
    title.innerHTML = `Please check the preview carefully`;
    content.classList.add("preview-bodyline");
    content.innerHTML = `Make sure the below customization is correct to receive your item faster`;
    heading.append(title);
    heading.append(content);

    button.classList.add("button");
    button.classList.add("button--primary");
    button.classList.add("button--filled");
    button.classList.add("button--primary__filled");
    button.classList.add("ld-over-inverse");
    button.innerHTML = `<span>ADD TO CART</span>
      <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="display: none; position: absolute; inset: 0; width: 44px; height: auto; margin: auto; z-index: 9;">
          <path fill="#fff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
        </path>
      </svg>
    `;

    button.style.bottom = "0";

    button_close.classList.add("button");
    button_close.classList.add("button--secondary");
    button_close.classList.add("button--filled");
    button_close.classList.add("button--primary__filled");
    button_close.classList.add("ld-over-inverse");
    button_close.innerHTML = `<span>CLOSE</span>`;
    button_close.style.bottom = "0";

    action.append(button);
    action.append(button_close);

    control_mobile.classList.add("control-mobile");
    // control_mobile_image.classList.add('control-mobile-image');
    control_mobile_content.classList.add("control-mobile-content");
    control_mobile_content.innerHTML = `<p>Resizing your photo with buttons above. Your product will be exactly as the preview. Re-upload if needed.</p>`;
    // control_mobile.append(control_mobile_image);
    control_mobile.append(control_mobile_content);

    if (window.innerWidth < 1150) {
      action.style.marginTop = "10px";
    } else {
      action.style.marginTop = "15px";
    }

    button.addEventListener("click", function () {
      button.classList.add("active");
      const loader = setInterval(() => {
        document
          .querySelector(".customily-modal-preview-only")
          .setAttribute("style", "padding: 10px 0px; justify-content: center;");
      });
      button.querySelector("svg").style.display = "block";
      document.getElementById("customily-cart-btn").click();
      document.querySelector(".customily-close-button").click();

      setTimeout(function () {
        clearInterval(loader);
      }, 800);
    });

    button_close.addEventListener("click", function () {
      document.querySelector(".customily-close-button").click();
    });

    document.querySelector(".customily-modal-preview-only").style.padding =
      "10px 0";
    document.querySelector(
      ".customily-modal-preview-only"
    ).style.justifyContent = "center";
    document
      .querySelector(".customily-modal-preview-only")
      .querySelector(".main")
      .prepend(heading);
    document
      .querySelector(".customily-modal-preview-only")
      .querySelector(".main")
      .appendChild(control_mobile);
    document
      .querySelector(".customily-modal-preview-only")
      .querySelector(".main")
      .appendChild(action);
    container.appendChild(
      document
        .querySelector(".customily-modal-preview-only")
        .querySelector(".main")
    );
    document
      .querySelector(".customily-modal-preview-only")
      .appendChild(container);
  }
});

window.addEventListener("customily-preview-load-finished", function (e) {
  console.log("customily-preview-load-finished");
  let guideline = false;
  document.querySelectorAll(".customily-download-button").forEach((button) => {
    if (button.textContent.includes("Select Image")) {
      guideline = true;
      return;
    }
  });

  const productData = document.getElementById("customily-product-guideline")
    ? JSON.parse(
        document.getElementById("customily-product-guideline").textContent
      )
    : {};

  if (productData.dataGuideline !== undefined || guideline) {
    function insertAfter(newNode, existingNode) {
      existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }

    setInterval(() => {
      if (
        document.querySelectorAll(".customily-file-input + .help-text").length
      ) {
        document
          .querySelectorAll(".customily-file-input + .help-text")
          .forEach((help_text) => {
            if (!help_text.hasAttribute("done-postion")) {
              help_text.toggleAttribute("done-postion");
              help_text.innerHTML = `<button type="button" onclick="document.querySelector('.modal-custom').classList.add('modal--active')" style="display: flex; align-items: center; gap: 6px; margin: 10px 0px;">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" id="footer-sample-full" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512" class="iconify iconify--fa-solid"><path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758c-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122c17.864-22.658 30.113-35.797 57.303-35.797c20.429 0 45.698 13.148 45.698 32.958c0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667c0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46c0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z" fill="currentColor"></path></svg>
                <i>View photo upload guidelines here</i>
              </button`;
            }
          });
      }

      if (document.querySelectorAll(".customily-file-input")) {
        document
          .querySelectorAll(".customily-file-input")
          .forEach((customFile) => {
            if (
              !customFile.hasAttribute("done-postion") &&
              customFile.nextElementSibling &&
              !customFile.nextElementSibling.classList.contains("help-text")
            ) {
              customFile.toggleAttribute("done-postion");
              const small = document.createElement("small");
              small.classList.add("help-text");
              small.setAttribute("style", "white-space: pre-wrap;");
              small.innerHTML = `<button type="button" onclick="document.querySelector('.modal-custom').classList.add('modal--active')" style="display: flex; align-items: center; gap: 6px; margin: 10px 0px;">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" id="footer-sample-full" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512" class="iconify iconify--fa-solid"><path d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758c-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122c17.864-22.658 30.113-35.797 57.303-35.797c20.429 0 45.698 13.148 45.698 32.958c0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667c0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46c0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z" fill="currentColor"></path></svg>
                <i>View photo upload guidelines here</i>
              </button`;
              insertAfter(small, customFile);
            }
          });
      }
    });

    const Customly = setInterval(() => {
      if (document.querySelector(".customily-main-app")) {
        clearInterval(Customly);
        // Check if the heading already exists
        if (!document.querySelector(".cl_optionsapp--heading")) {
          const h3 = document.createElement("h3");
          const guideline = document.createElement("span");
          const heading = document.createElement("div");

          h3.textContent = "Craft Your Own Gift";
          h3.style.textAlign = "center";
          h3.style.padding = "0 0 5px";
          h3.style.width = "100%";
          h3.style.margin = "0";

          heading.classList.add("cl_optionsapp--heading");
          heading.style.display = "flex";
          heading.style.justifyContent = "flex-start";
          heading.style.alignItems = "flex-start";
          heading.style.flexDirection = "column";
          heading.style.padding = "10px 0";
          heading.style.textAlign = "left";
          heading.style.borderBottom = "1px solid #ccc";

          guideline.classList.add("js-trigger-product-popup__link");
          guideline.textContent = `ⓘ View photo upload guidelines here`;
          guideline.style.cursor = "pointer";
          guideline.style.color = "var(--main-color)";

          heading.appendChild(h3);
          heading.appendChild(guideline);

          document.getElementById("cl_optionsapp").prepend(heading);

          guideline.addEventListener("click", function () {
            if (document.querySelector(".js-customily-guideline") != null) {
              document.querySelector(".js-customily-guideline").click();
            }
          });
        }
      }
    });
  }
});
